import { FormItem, Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useXRechnungEInvoicingAddressForm } from '../../../../../../contexts/xRechnungEInvoicingAddressFormContext'

export const ReceiverName = (): ReactElement => {
  const { t } = useTranslation()
  const { receiverName } = useXRechnungEInvoicingAddressForm()

  return (
    <FormItem label={t('external_invoices.download_as_xrechnung.modal.form.field.receiver.label')}>
      <Input disabled value={receiverName} size="sm" />
    </FormItem>
  )
}
